import React, { useMemo } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { CustomAccordion } from 'components/Ui/styled';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { CannedResponsesWrapper } from '../../ssaComponentStyled';
import { NotesTypography } from 'layouts/inventory/Inventory.styled';
import CopyButton from 'layouts/studentSuccessAdvocate/cannedResponses/components/cannedResponsesUtils';

const CannedResponseItem = React.memo(({ item }) => {
  return (
    <CannedResponsesWrapper
      container
      alignItems="center"
      justifyContent="space-between"
    >
      <Grid item xs padding="10px">
        <NotesTypography variant="h6">{item.text}</NotesTypography>
      </Grid>

      <Grid item>
        <CopyButton text={item.text} />
      </Grid>
    </CannedResponsesWrapper>
  );
});

const CannedResponsesAccordion = ({ cannedResopnse = [] }) => {
  const pinnedResponses = useMemo(
    () => cannedResopnse?.filter((item) => item?.pinned),
    [cannedResopnse],
  );

  if (!pinnedResponses.length) return null;

  return (
    <CustomAccordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">
          📌 Pinned Responses ({pinnedResponses.length})
        </Typography>
      </AccordionSummary>

      <AccordionDetails>
        {pinnedResponses?.map((item) => (
          <CannedResponseItem key={item.resourceId} item={item} />
        ))}
      </AccordionDetails>
    </CustomAccordion>
  );
};

export default CannedResponsesAccordion;
